const MobileSticky = () => {
  const widget = document.querySelector('.js-mobile-housing-widget')
  const windowHeight = window.innerHeight;
  let isactive = false
  let resetactive

  if(!widget){ return;}

  console.log(windowHeight)

  document.addEventListener('scroll', e => {
    let bottom = widget.getBoundingClientRect().bottom - windowHeight;
    if(bottom < 0  && isactive == false){
      isactive = true
      widget.classList.add("c-mobile-housing-widget--active")
      resetactive = window.scrollY;
    }
    if (window.scrollY < resetactive && isactive == true){
      isactive = false
      widget.classList.remove("c-mobile-housing-widget--active")
    }
  })
}

export default MobileSticky




// WEBPACK FOOTER //
// ./src/js/modules/MobileSticky.js